import { FaHistory } from 'react-icons/fa';
import type { AboutSectionData } from '@/sanity/types';

interface AboutHistorySectionProps {
  data?: AboutSectionData | undefined;
}

/**
 * R2 - Company history section for About Us page
 * R4 - Accepts optional Sanity data, falls back to hardcoded defaults
 */
export function AboutHistorySection({ data }: AboutHistorySectionProps) {
  const badge = data?.historyBadge ?? 'Nuestra Historia';
  const title = data?.historyTitle ?? 'Una década de experiencia';
  const paragraph1 = data?.historyParagraph1 ?? 'Fundada en <strong class="text-inboca-teal">2014</strong> por Miguel López, nuestra empresa nació con el propósito de ofrecer soluciones modulares prácticas, eficientes y adaptadas a las necesidades de cada cliente.';
  const paragraph2 = data?.historyParagraph2 ?? 'Con sede en <strong class="text-inboca-teal">Albacete</strong>, nos hemos consolidado como un referente en el sector del alquiler y la venta de módulos prefabricados.';
  return (
    <section className="relative py-20 sm:py-32 bg-white">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Icon + Visual */}
          <div className="animate-fade-in-up">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-inboca-teal/10 rounded-full blur-2xl" />
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-inboca-orange/10 rounded-full blur-2xl" />
              <div className="relative bg-gradient-to-br from-slate-50 to-inboca-gray rounded-3xl p-12 flex items-center justify-center">
                <div className="h-32 w-32 rounded-2xl bg-gradient-to-br from-inboca-teal/20 to-inboca-orange/20 flex items-center justify-center">
                  <FaHistory className="h-16 w-16 text-inboca-teal" />
                </div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <span className="inline-block px-4 py-2 bg-inboca-orange/10 rounded-full text-inboca-orange font-semibold text-sm mb-6">
              {badge}
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              {title}
            </h2>
            <p
              className="text-lg text-gray-700 leading-relaxed mb-6"
              dangerouslySetInnerHTML={{ __html: paragraph1 }}
            />
            <p
              className="text-lg text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: paragraph2 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
